
import { Command, SelfContainedCommand } from "types/commands";
import { docsInsertTableCommand } from './docs_insert_table';
import { docsCreateCommand } from './docs_create';

export const commands: (SelfContainedCommand | Command)[] = [
    // Existing commands (v1)
    docsInsertTableCommand,
    docsCreateCommand,
];
